import { langArr } from "../Translation/language"

export const acceptedLang = (lang) => {
  if (lang?.toLowerCase() in langArr) {
    return true;
  }

  return false;
}
